/**
 * Document type slugs
 */

export const DOCUMENT_TYPE = {
  QUOTE: 'quote',
  INVOICE: 'invoice',
  CREDIT_NOTE: 'credit_note',
  CONTRACT: 'contract',
  REPORT: 'report',
  PAYMENT: 'payment',
  CLIENT: 'client',
  INTERVENTION_REPORT: 'intervention_report',
} as const

export type DocumentType = (typeof DOCUMENT_TYPE)[keyof typeof DOCUMENT_TYPE]

/** doc_type values allowed for Settings document templates (2.11.14-2.11.18). */
export const TEMPLATE_DOCUMENT_TYPES = [
  DOCUMENT_TYPE.QUOTE,
  DOCUMENT_TYPE.INVOICE,
  DOCUMENT_TYPE.CREDIT_NOTE,
  DOCUMENT_TYPE.CONTRACT,
  DOCUMENT_TYPE.REPORT,
  DOCUMENT_TYPE.INTERVENTION_REPORT,
] as const

export type TemplateDocumentType = (typeof TEMPLATE_DOCUMENT_TYPES)[number]

export function isTemplateDocumentType(
  value: string
): value is TemplateDocumentType {
  return (TEMPLATE_DOCUMENT_TYPES as readonly string[]).includes(value)
}
